import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import { TextField, InputAdornment, useTheme } from "@mui/material";
import useSearchStore from "../../stores/store-query-filters";

/**
 * Reusable search bar component with a consistent style across the application.
 * Manages its own query state via the global search store (store-query-filters).

 */

interface SearchBarProps {
  searchKey: string;
  onSearch?: () => void;
}

const SearchBar = ({ searchKey, onSearch }: SearchBarProps) => {
  const searchQuery = useSearchStore((state) => state.getSearch(searchKey));
  const setSearch = useSearchStore((state) => state.setSearch);
  const theme = useTheme();

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(searchKey, event.target.value);
    onSearch?.();
  };

  return (
    <TextField
      fullWidth
      placeholder="Suchen..."
      value={searchQuery}
      onChange={handleSearchChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
      sx={{
        minWidth: "200px",
        maxWidth: "300px",
        "& .MuiOutlinedInput-root": {
          backgroundColor: "transparent",
          borderRadius: "20px",
          border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'}`,
        },
        "& .MuiOutlinedInput-input": {
          color: "inherit",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          border: "none",
        },
      }}
    />
  );
};

export default SearchBar;